import { Pipe, PipeTransform } from '@angular/core';

const courierLinks = new Map<string, string>([
  ['postnord', 'https://tracking.postnord.com/en/?id=***AWB***'],
  ['bring', 'https://tracking.bring.dk/tracking/***AWB***?lang=en'],
  ['dhl express', 'https://mydhl.express.dhl/dk/en/tracking.html#/results?id=***AWB***'],
  [
    'dhl freight',
    'https://activetracing.dhl.com/DatPublic/datSelection.do?search=consignmentId&at=cons_ordercode&valueShipmentOrderField=***AWB***&focus=search2&searchConsignmentId=track'
  ],
  ['dpd', 'https://www.dpdlocal.co.uk/apps/tracking/?reference=***AWB***'],
  ['fedex', 'https://www.fedex.com/fedextrack/?trknbr=***AWB***'],
  ['gls', 'https://gls-group.eu/DK/en/parcel-tracking?match=***AWB***&txtAction=71000'],
  ['posti', 'https://www.posti.fi/henkiloasiakkaat/seuranta/#/***AWB***'],
  ['seur', 'https://www.seur.com/livetracking/?segOnlineIdentificador=***AWB***&segOnlineIdioma=es'],
  ['tnt', 'http://www.tnt.com/webtracker/tracking.do?cons=***AWB***'],
  [
    'ups',
    'http://wwwapps.ups.com/WebTracking/processInputRequest?HTMLVersion=5.0&Requester=UPSHome&tracknum=***AWB***&AgreeToTermsAndConditions=yes&ignore=&track.x=26&track.y=2'
  ]
]);

@Pipe({
  name: 'courierTrackingLinks',
  standalone: true
})
export class CourierTrackingLinksPipe implements PipeTransform {
  transform(carrier: string | null, masterNo: string | null): string {
    if (!masterNo || !carrier) {
      return '';
    }
    return courierLinks.get(carrier.toLowerCase())?.replace('***AWB***', masterNo) || '';
  }
}
